export default __webpack_public_path__ + "static/media/br.0869ee78.svg";